export class SystemMessagesConstants {
    public static getSystemMessagesUrl = 'retail-web/retail-account-requests/messages';
}

